<template>
  <div v-if="shouldShowWarning" style="display: flex;width: 100%;background: #ef5350;align-items: center;">
    <div style="color: white;padding: 10px;width: 95%;">
      You need to update the ERP login credentials
      <span @click="goToLoginCredentials()" style="color: white; text-decoration: underline; cursor: pointer;">here!</span>
    </div>
  </div>
  <div class="page-report">
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">ERP</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>POS Data For ERP</h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              @reload-data="getList"
              @export="exportFile"
              :serviceUploadType="serviceUploadType"
              :hasSelected="selectedIds.length > 0"
            ></FormSearch>
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder w-5">
                              <material-checkbox
                                @click="toggleCheckAll"
                                :checked="isCheckedAll"
                                :modelValue="isCheckedAll"
                                class="align-items-center checkbox-custom"
                              />
                            </th>
                            <th class="text-center font-weight-bolder">
                              <div class="pt-4">Row No</div>
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-4"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                              </th>
                            </template>
                          </tr>
                          <tr>
                            <th class="text-center font-weight-bolder"></th>
                            <th class="text-center font-weight-bolder">
                              <input
                                v-model="columnSearch[1]"
                                @input="searchColumn(1)"
                              />
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-if="index < headersData.length - 1"
                                  v-model="columnSearch[index + 2]"
                                  @input="searchColumn(index + 2)"
                                />
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="transactionData.length">
                          <tr
                            v-for="(value, key) in transactionData"
                            :key="key"
                            :class="{
                              'total-row': key + 1 == transactionData.length,
                            }"
                          >
                            <td class="text-center text-xss">
                              <material-checkbox
                                v-if="key != transactionData.length - 1"
                                @click="toggleCheckItem(value.id)"
                                :checked="selectedIds.includes(value.id)"
                                :modelValue="selectedIds.includes(value.id)"
                                class="align-items-center checkbox-custom"
                              />
                            </td>
                            <td class="text-right text-xss">
                              {{
                                key != transactionData.length - 1 ? key + 1 : ""
                              }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.documentdate }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.operationid }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.companycode }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value.documentnumber }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value.gross_amount) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value.disc_amount) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value.tax_amount) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value.total_amount) }}
                            </td>
                            <!-- <td class="text-left text-xss">
                              <div
                                v-if="key === transactionData.length - 1"
                              ></div>
                              <div
                                v-else-if="value.uploaded"
                                class="text-success"
                              >
                                Yes
                              </div>
                              <div v-else class="text-danger">No</div>
                            </td> -->
                            <td class="text-left text-xss">
                              {{ value.uploaddate }}
                            </td>
                            <td class="text-left text-xss">
                              <div class="d-flex justify-content-between">
                                <div
                                  v-if="value.uploaded == 1"
                                  class="text-success"
                                >
                                  Success
                                </div>
                                <div
                                  v-else-if="value.uploaded == -1"
                                  class="text-danger"
                                >
                                  Failed
                                </div>
                                <div v-else></div>
                                <div v-if="key != transactionData.length - 1 && value.uploaded != 0" class="ms-3 tag-a-custom" @click="uploadResponse(value.id, 1)">Log</div>
                              </div>
                            </td>
                            <td class="text-left text-xss">
                              {{ getUploadDate(value) }}
                            </td>
                            <td class="text-left text-xss">
                              <div class="d-flex justify-content-between">
                                <div
                                  v-if="getUploadStatus(value) == 1"
                                  class="text-success"
                                >
                                  Success
                                </div>
                                <div
                                  v-else-if="getUploadStatus(value) == -1"
                                  class="text-danger"
                                >
                                  Failed
                                </div>
                                <div v-else></div>
                                <div v-if="key != transactionData.length - 1 && getUploadStatus(value) != 0" class="ms-3 tag-a-custom" @click="uploadResponse(value.id, 2)">Log</div>
                              </div>
                            </td>
                            <td class="text-center text-xss">
                              <div v-if="key != transactionData.length - 1">
                                <div
                                  class="tag-a-custom me-3"
                                  @click="viewErp(value.id)"
                                >
                                  View
                                </div>
                                <div
                                  v-if="value.uploaded != 1 || getUploadStatus(value) != 1"
                                  class="tag-a-custom"
                                  @click="chooseUploadOption(value.id)"
                                >
                                  Upload
                                </div>
                                <div
                                  v-if="value.uploaded != 1"
                                  class="ms-3 tag-a-custom"
                                  style="color: red !important"
                                  @click="confirmDeleteErp(value.id)"
                                >
                                  Delete
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/erp-collections/export`"
      method="POST"
      accept-charset="UTF-8"
      enctype="application/x-www-form-urlencoded; charset=UTF-8"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="branch_id" :value="form.branch_id" />
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="type" value="1" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input type="hidden" name="selected_ids" :value="selected_ids_export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
    <ErpDetail
      :keyReload="keyReload"
      :idSelected="idSelected"
      :isEdit="true"
      @reload-data="reloadData"
    ></ErpDetail>
    <UploadResponse
      :keyReload="keyReload"
      :idSelected="idSelected"
      :typeErp="typeErp"
      :serviceUploadType="serviceUploadType"
    ></UploadResponse>
    <ModalSaveDraftSuccess :id="documentNumberDraft" />
    <ModalConfirm
      message="Are you sure you want to submit this invoice?"
      :process-yes="uploadErp"
    />
    <ModalConfirmDelete
      message="Are you sure you want to delete this invoice?"
      :process-yes="deleteErp"
    />
    <ModalChooseUploadOption :confirmUploadErp="confirmUploadErp" :serviceUploadType="serviceUploadType" />
    <XeroErrorModal @ok="openUploadResponseModal" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vueform/multiselect/themes/default.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import ErpDetail from "./components/ModalErpDetail.vue";
import UploadResponse from "./components/ModalErpUploadResponse.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalSaveDraftSuccess from "./components/ModalSaveDraftSuccess.vue";
import ModalConfirmDelete from "@/components/ModalConfirmDelete.vue";
import ModalChooseUploadOption from "./components/ModalChooseUploadOption.vue";
import XeroErrorModal from "./components/XeroErrorModal.vue";
import "datatables.net";

export default {
  name: "erp-collections-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    MaterialCheckbox,
    ErpDetail,
    ModalConfirm,
    ModalConfirmDelete,
    ModalSaveDraftSuccess,
    UploadResponse,
    ModalChooseUploadOption,
    XeroErrorModal
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      transactionData: [],
      selectedIds: [],
      form: {
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      selected_ids_export: "",
      dataTable: null,
      tableData: [],
      columnSearch: [],
      keyReload: "keyReload",
      idSelected: 0,
      documentNumberDraft: "",
      erpConfig: null,
      isShowWarningSms: false,
      uploadType: 1,
      serviceUploadType: 1,
      typeErp: 1,
    };
  },
  created() {
    this.getLoginCredentials();
  },
  computed: {
    headersData() {
      return [
        {
          label: "Date Time",
          field: "documentdate",
          hasSortBy: true,
        },
        {
          label: "Operation Id",
          hasSortBy: false,
        },
        {
          label: "Company Code",
          hasSortBy: false,
        },
        {
          label: "Document Number",
          hasSortBy: false,
        },
        {
          label: "Gross Amt",
          field: "gross_amount",
          hasSortBy: true,
        },
        {
          label: "Disc Amt",
          field: "disc_amount",
          hasSortBy: true,
        },
        {
          label: "Tax Amt",
          field: "tax_amount",
          hasSortBy: true,
        },
        {
          label: "Total",
          field: "total_amount",
          hasSortBy: true,
        },
        // {
        //   label: "Submitted",
        //   hasSortBy: false,
        // },
        {
          label: "Inv Submitted Time",
          hasSortBy: false,
        },
        {
          label: "Inv Submitted Status",
          hasSortBy: false,
        },
        {
          label: this.serviceUploadType === 2 || this.serviceUploadType === 3 ? "Payment Submitted Time" : "Receipt Submitted Time",
          hasSortBy: false,
        },
        {
          label: this.serviceUploadType === 2 || this.serviceUploadType === 3 ? "Payment Submitted Status" : "Receipt Submitted Status",
          hasSortBy: false,
        },
        {
          label: "Action",
          hasSortBy: false,
        },
      ];
    },
    isXeroOrQbo() {
      return this.serviceUploadType === 2 || this.serviceUploadType === 3;
    },
    getUploadDate() {
      return (value) => this.isXeroOrQbo ? value.uploaddate_payment : value.uploaddate_receipt;
    },
    getUploadStatus() {
      return (value) => this.isXeroOrQbo ? value.uploaded_payment : value.uploaded_receipt;
    },
    shouldShowWarning() {
      const isNormalErpWarning = this.isXeroOrQbo ? false : this.isShowWarningSms && (!this.erpConfig || !this.erpConfig.authentication);
      return isNormalErpWarning;
    },
    selectableIds() {
      // Exclude the last "total" row from selection if present
      const hasTotalRow = this.transactionData.length > 0;
      const dataRows = hasTotalRow ? this.transactionData.slice(0, -1) : this.transactionData;
      return dataRows.map((item) => item.id).filter(Boolean);
    },
    isCheckedAll() {
      return (
        this.selectableIds.length > 0 &&
        this.selectableIds.every((id) => this.selectedIds.includes(id))
      );
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      price = parseFloat(price).toFixed(2);
      return (
        "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },

    viewErp(id) {
      this.idSelected = id;
      this.keyReload = Math.random();
      $(".show-modal-erp-detail").click();
    },

    uploadResponse(id, type) {
      this.typeErp = type;
      this.idSelected = id;
      this.keyReload = Math.random();
      $(".show-modal-erp-upload-response").click();
    },

    async exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      // Ensure we only send list of IDs: "id1,id2,id3"
      this.selected_ids_export = this.selectedIds
        .map((x) => (x && typeof x === "object" ? x.id : x))
        .filter((x) => x !== undefined && x !== null && x !== "")
        .join(",");

      if (type === "csv_to_xero") {
        this.showLoader();

        try {
          const dataForm = {
            merchantId: this.merchantIdExport,
            merchant_code: this.merchantCode,
            token: this.token,
            branch_id: this.form.branch_id,
            from_date: this.from_date_export,
            to_date: this.to_date_export,
            type: 1,
            action_export: this.action_export,
            action: "export",
            selected_ids: this.selected_ids_export
          };

          const response = await AnalyticsService.exportErpCollections(dataForm);

          const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
          const blob = new Blob([bom, response.data], {
            type: "text/csv;charset=utf-8;"
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `xero_sales_invoices_${Date.now()}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.hideLoader();
        } catch (error) {
          this.hideLoader();
          this.snackbar = "danger";
          this.message = error.response?.data?.result?.message || error.message || "Export failed";
          this.setTimeOutNotification();
        }
      } else {
        setTimeout(() => {
          $("#downloadForm").click();
        }, 150);
      }
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "-1";
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }

      this.dataTable = $(this.$refs.dataTable).DataTable({
        paging: false,
        searching: true,
        ordering: false,
        info: false,
      });
    },

    searchColumn(index) {
      this.dataTable.column(index).search(this.columnSearch[index]).draw();
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      const direction = this.ESortDirectionSelect.direction;

      this.transactionData.sort(function (item, item2) {
        if (direction == "asc") {
          if (item[field] > item2[field]) return 1;
          if (item[field] < item2[field]) return -1;
        }

        if (direction == "desc") {
          if (item[field] < item2[field]) return 1;
          if (item[field] > item2[field]) return -1;
        }

        return 0;
      });
    },

    goToLoginCredentials() {
      this.$router.push("/erp/login-credentials");
    },

    getLoginCredentials() {
      this.isShowWarningSms = false;
      this.showLoader();

      AnalyticsService.getLoginCredentials().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.erpConfig = response.data.data;
            this.serviceUploadType = parseInt(response.data.data.service_upload_type);
            this.isShowWarningSms = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    getList() {
      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;
      this.showLoader();
      var dataForm = {
        branch_id: this.form.branch_id,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
        type: 1
      };

      AnalyticsService.erpCollectionsReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transactionData = response.data.data;
            this.selectedIds = [];
            const totalColumn = this.headersData.length;
            // columns = checkbox + row no + headersData
            const columnCount = totalColumn + 2;
            this.columnSearch = Array(columnCount).fill("");

            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    reloadData(message = "", documentNumber = null) {
      this.documentNumberDraft = documentNumber;

      if (message != "") {
        this.snackbar = "success";
        this.message = message;
        this.setTimeOutNotification();

        if (documentNumber) {
          $(".btn-save-draft-success").click();
        }
      }

      this.getList();
    },

    toggleCheckAll() {
      if (this.isCheckedAll) {
        this.selectedIds = [];
      } else {
        this.selectedIds = [...this.selectableIds];
      }
    },

    toggleCheckItem(id) {
      if (!id) return;
      const exists = this.selectedIds.includes(id);
      if (exists) {
        this.selectedIds = this.selectedIds.filter((itemId) => itemId !== id);
      } else {
        this.selectedIds = [...this.selectedIds, id];
      }
    },

    chooseUploadOption(id) {
      this.idSelected = id;
      $(".show-modal-choose-upload-option").click();
    },

    confirmUploadErp(type) {
      $(".hide-modal-choose-upload-option").click();
      this.uploadType = type;
      $(".btn-confirm-modal").click();
    },

    async uploadErp() {
      $(".btn-close-modal").click();
      this.showLoader();
      var dataForm = {
        id: this.idSelected,
        type: this.uploadType
      };

      let uploadFunction = null;
      const serviceType = parseInt(this.erpConfig.service_upload_type);

      if (serviceType === 1) {
        uploadFunction = AnalyticsService.uploadErp;
      } else if (serviceType === 2) {
        uploadFunction = AnalyticsService.uploadXeroErp;
      } else if (serviceType === 3) {
        uploadFunction = AnalyticsService.uploadQuickbooksErp;
      }

      if (uploadFunction) {
        await uploadFunction(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Invoice submitted successfully!";
              this.setTimeOutNotification();
              this.idSelected = 0;
              this.uploadType = 1;
              this.getList();
            } else {
              if (serviceType === 2) {
                this.showXeroErrorModal();
              } else {
                this.snackbar = "danger";
                this.message =
                  "Invoice submitted failed. Error Message: " +
                  response.data.result.message;
                this.setTimeOutNotification();
                this.idSelected = 0;
                this.uploadType = 1;
                this.getList();
              }
            }
            this.hideLoader();
          },
          (error) => {
            if (serviceType === 2) {
              this.showXeroErrorModal();
            } else {
              this.snackbar = "danger";
              this.message = error;
              this.setTimeOutNotification();
              this.idSelected = 0;
              this.uploadType = 1;
              this.getList();
            }
            this.hideLoader();
          }
        );
      }
    },

    confirmDeleteErp(id) {
      this.idSelected = id;
      $(".btn-confirm-modal-delete").click();
    },

    async deleteErp() {
      $(".btn-close-modal").click();
      this.showLoader();

      await AnalyticsService.deleteErp(this.idSelected).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Delete invoice successfully!";
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );

      this.idSelected = 0;
      this.getList();
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    showXeroErrorModal() {
      $(".show-modal-xero-error").click();
    },

    openUploadResponseModal() {
      this.typeErp = this.uploadType;
      this.keyReload = Math.random();
      setTimeout(() => {
        $(".show-modal-erp-upload-response").click();
      }, 300);
    },
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        setTimeout(() => {
          this.initializeDataTable();
          this.isLoadDoneDataTable = true;
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

tbody > tr.total-row {
  font-weight: bold;
  color: #222;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

.tag-a-custom {
  color: #007bff !important;
  text-decoration: underline !important;
  cursor: pointer;
  display: inline-block;
}

.text-success {
  color: #28a745 !important;
}
</style>
